<template>
    <div v-if="messages" class="chat d-flex flex-grow-1">
        <div id="mainMessages" class="chat_conversion chat_converse d-flex flex-grow-1 flex-column" @scroll="handleScroll">
            <ChatMessage
                v-for="(message, i) in messages"
                :key="i"
                :model-value="message"
                :myUser="user"
                right
                showUser
            ></ChatMessage>
        </div>
        <ChatForm ref="form" v-if="!disabled && !is_banned && !publicUser" :moderate="chat.moderate" v-model="message" :send="send" showupload :user="user" @success="success" @delete="removeFile" :max="255"></ChatForm>
        <div v-else-if="is_banned" class="card my-0 px-3 py-2 text-danger"> {{$t('chat.you_are_banned')}} </div>
        <div v-else-if="disabled" class="card my-0 px-3 py-2"> {{$t('chat.end')}} </div>
        <div v-else-if="publicUser" class="card my-0 px-3 py-2"> {{$t('chat.needs_login')}} </div>
    </div>
</template>

<script>

import ChatForm from './ChatForm';
import ChatMessage from './ChatMessage';
import WSChat from './mixins/WSChat';

export default {
    emits: ['input', 'update:modelValue', 'liveSettings'],

    name: 'ChatLive',

    components: {
        ChatMessage,
        ChatForm,
    },

    props: {
        user: Object,
        modelValue: Object,
        disabled: [Boolean, Number],
    },

    mixins: [
        WSChat,
    ],

    data() {
        return {
            autoScroll: true,
            currentPage: 1,
            hasMoreMessages: true,
        };
    },
    mounted() {
        this.joinRoom();
    },

    computed: {

        chat: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
                this.$emit('input', value);
            },
        },

        publicUser() {
            return this.$store.getters.USER.public;
        },
    },

    methods: {
        handleScroll(event) {
            const scrollTop = event.target.scrollTop;
            if (scrollTop === 0 && this.hasMoreMessages) {
                this.listMessages(this.currentPage + 1);
                this.currentPage++;
            }
        },

        success(upload = this.upload) {
            this.upload = {
                // o upload-local devolve o nome original em `name`
                filename: upload.filename || upload.name,
                hash: upload.hash,
                height: upload.height,
                host: upload.host,
                mime: upload.mime,
                original_file: upload.original_file,
                path: upload.path,
                size: upload.size,
                type: upload.type,
                width: upload.width,
                status: 1,
            };
        },

        send() {
            this.addMessage(...arguments);
            this.$refs.form.reset();
            this.upload = null;
        },

        removeFile() {
            axios.delete(`/api/upload-local/delete/${this.upload.hash}`, {

            });
            this.$refs.form.reset(false);
            this.upload = null;
        },

    },
};

</script>

<style scoped>
    .chat {
        width: 100%;
        display: flex;
        flex-direction: column
    }

    .chat_converse {
        position: relative;
        background: #fff;
        max-height: 100%;
        min-height: 0;
        max-height: 70vh;
        font-size: 14px;
        line-height: 18px;
        overflow-y: auto;
        width: 100%;
        float: right;
        padding-bottom: 30px;
    }

    /*Chatbox scrollbar*/

    ::-webkit-scrollbar {
        width: 6px;
    }

    ::-webkit-scrollbar-track {
        border-radius: 0;
    }

    ::-webkit-scrollbar-thumb {
        margin: 2px;
        border-radius: 10px;
        background: rgba(0, 0, 0, 0.2);
    }

</style>
